import React, {Fragment, useEffect, useRef} from 'react';
import {Animated, TouchableOpacity, View, StyleSheet} from 'react-native';
import {Text} from '../../text';
import {Link} from '../../link';
import {images} from '../../../../assets/icons';
import {useTheme} from '../../../theme';
import {useIsDesktop} from '../../../hooks/useIsDesktop';
import {CustomScrollView} from '../../scrollView';
import {useMapDetailsStyles} from './MapDetails.style';
import {Detail} from '../types';

interface MapDetailsProps {
  details: Detail[];
  isDetailsVisible: boolean;
  onCloseDetails?: () => void;
}

export function MapDetails({details, isDetailsVisible, onCloseDetails}: MapDetailsProps) {
  const theme = useTheme();
  const styles = useMapDetailsStyles();
  const isDesktop = useIsDesktop();
  const left = useRef(new Animated.Value(-1000)).current;

  const closeButonIconProps = StyleSheet.flatten(styles.closeButonIcon);

  useEffect(() => {
    Animated.timing(left, {useNativeDriver: false, toValue: isDetailsVisible ? 0 : -1000}).start();

    return () => {
      left.stopAnimation();
    };
  }, [isDetailsVisible]);

  return (
    <Fragment>
      {!isDesktop && (
        <View style={[styles.backdrop, isDetailsVisible && styles.backdropVisible]}>
          <TouchableOpacity style={styles.backdropTouchable} onPress={onCloseDetails} />
        </View>
      )}

      <Animated.View style={[styles.info, {left}]}>
        <TouchableOpacity testID='all-accesptor-click-id' style={styles.closeButton} onPress={onCloseDetails}>
          <images.Close {...closeButonIconProps} />
        </TouchableOpacity>

        <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
          {details
            .filter((detailsItem) => detailsItem.show ?? true)
            .map(({title, info}, index) => (
              <View key={title + index} style={styles.infoBlock}>
                <Text style={[styles.infoRow, styles.title]}>{title}</Text>
                {info
                  .filter((infoItem) => infoItem.show ?? true)
                  .map((infoItem, i) => (
                    <View
                      key={infoItem.text + i}
                      style={[styles.infoRow, infoItem.icon ? styles.rowWithIcon : undefined]}>
                      {infoItem.href ? (
                        <Link external testID='phone-geo-map-link-id' href={infoItem.href} style={styles.groupItem}>
                          {infoItem.icon && <View style={styles.icon}>{infoItem.icon}</View>}
                          <Text style={styles.text}>{infoItem.text}</Text>
                        </Link>
                      ) : (
                        <Fragment>
                          {infoItem.icon && <View style={styles.icon}>{infoItem.icon}</View>}
                          <Text style={styles.text}>{infoItem.text}</Text>
                        </Fragment>
                      )}
                    </View>
                  ))}
              </View>
            ))}
        </CustomScrollView>

        {isDesktop && (
          <View style={styles.bgImage}>
            <images.AcceptorMap width='100%' color={theme.polls.shapes.color} />
          </View>
        )}
      </Animated.View>
    </Fragment>
  );
}
